export function getSurveys ({ state, commit }, page = 1) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/surveys', { params: { page: page } })
      .then((response) => {
        if (response.data.surveys) {
          commit('setSurveys', response.data.surveys)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getSurvey ({ state, commit }, surveyId) {
  return new Promise((resolve, reject) => {
    if (surveyId) {
      axiosInstance.get('/v1/surveys/' + surveyId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No survey id'))
    }
  })
}

export function getCreateSurvey ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/surveys/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createSurvey ({ state, commit }, { subject, extra_message, date_to_send, date_expire, survey_type_id, anonymous, warehouse, survey_content, show_thanks }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/surveys', { subject, extra_message, date_to_send, date_expire, survey_type_id, anonymous, warehouse, survey_content, show_thanks })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditSurvey ({ state, commit }, surveyId) {
  return new Promise((resolve, reject) => {
    if (surveyId) {
      axiosInstance.get('/v1/surveys/' + surveyId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No survey id'))
    }
  })
}

/* eslint-disable-next-line */
export function editSurvey ({ state, commit }, { id, subject, extra_message, date_to_send, date_expire, survey_type_id, anonymous, warehouse, survey_content, show_thanks }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/surveys/' + id, { subject, extra_message, date_to_send, date_expire, survey_type_id, anonymous, warehouse, survey_content, show_thanks })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No survey id'))
    }
  })
}

export function deleteSurvey ({ state, commit }, surveyId) {
  return new Promise((resolve, reject) => {
    if (surveyId) {
      axiosInstance.delete('/v1/surveys/' + surveyId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No survey id'))
    }
  })
}
